import { render, staticRenderFns } from "./RouteMetricsCard.vue?vue&type=template&id=1521b599&"
import script from "./RouteMetricsCard.vue?vue&type=script&lang=js&"
export * from "./RouteMetricsCard.vue?vue&type=script&lang=js&"
import style0 from "./RouteMetricsCard.vue?vue&type=style&index=0&id=1521b599&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports